import script from "./PerformanceNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceNotifications.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__